import appConfig from "./config";
import * as appSyncClient from "./realtime/appsync-client";
import * as wsClient from "./realtime/websocket-client";

const useWS = appConfig.WS_BASE_URL

const client = useWS ? wsClient : appSyncClient;

export const config = client.config || {};

// Keep GraphQL doc exports available for compatibility
export const subscribeBotMessageDoc = appSyncClient.subscribeBotMessageDoc;
export const sendUserMessageDoc = appSyncClient.sendUserMessageDoc;

export async function sendUserMessage(authToken, appId, sessionId, data) {
  return client.sendUserMessage(authToken, appId, sessionId, data);
}

export function subscribeBotMessage(authToken, appId, sessionId, next, error) {
  return client.subscribeBotMessage(authToken, appId, sessionId, next, error);
}